// MANAGEMENT SJT — Scoring Engine
// 24 scenarios · Most(2pts) + Least(1pt) = max 72 pts
// 6 dimensions mapped to management competency framework
import { SJT_MANAGEMENT_ITEMS } from "./questionBank.js";

export const SJT_MGMT_NORMS = {
  overall: { mean:47.8, sd:9.2, n:620 },
  by_level: {
    team_leader:   { mean:44.1, sd:9.0 },
    mid_manager:   { mean:49.6, sd:8.7 },
    senior_manager:{ mean:54.2, sd:7.8 },
  }
};

export const SJT_MGMT_BANDS = [
  { min:0,  max:20, label:"Developing",  color:"#dc2626", hire:"Significant development needed before management role." },
  { min:20, max:40, label:"Average",     color:"#d97706", hire:"Entry-level management. Structured coaching recommended." },
  { min:40, max:70, label:"Strong",      color:"#1d4ed8", hire:"Recommended for management roles with ongoing development." },
  { min:70, max:100,label:"Exceptional", color:"#059669", hire:"Strongly recommended. Demonstrates senior management judgement." },
];

export const SJT_MGMT_DIMENSIONS = [
  { id:"delegation",    label:"Delegation & Empowerment",  icon:"⬆",  items:[0,1,2]     },
  { id:"performance",   label:"Performance Management",    icon:"📊",  items:[3,4,5]     },
  { id:"conflict",      label:"Conflict Resolution",        icon:"🤝",  items:[6,7,8]     },
  { id:"development",   label:"Team Development",           icon:"🌱",  items:[9,10,11]   },
  { id:"decisions",     label:"Decision Making",            icon:"⚡",  items:[12,13,14]  },
  { id:"communication", label:"Communication & Feedback",   icon:"💬",  items:[15,16,17]  },
  { id:"operations",    label:"Operational Management",     icon:"⚙️",  items:[18,19,20]  },
  { id:"managing_up",   label:"Managing Up & Stakeholders", icon:"🔼",  items:[21,22,23]  },
];

export function scoreSJT_MGMT(mostAnswers, leastAnswers) {
  let totalScore = 0;
  const itemScores = [];
  SJT_MANAGEMENT_ITEMS.forEach((item, i) => {
    let s = 0;
    if (mostAnswers[i]  === item.most)  s += 2;
    if (leastAnswers[i] === item.least) s += 1;
    totalScore += s;
    itemScores.push(s);
  });
  const maxScore = SJT_MANAGEMENT_ITEMS.length * 3; // 72
  const norm = SJT_MGMT_NORMS.overall;
  const z = (totalScore - norm.mean) / norm.sd;
  const percentile = Math.min(99, Math.max(1, Math.round(50 + z * 17)));
  const band = SJT_MGMT_BANDS.find(b => percentile >= b.min && percentile < b.max) || SJT_MGMT_BANDS[0];
  const dimScores = {};
  SJT_MGMT_DIMENSIONS.forEach(dim => {
    const dimTotal = dim.items.reduce((sum, idx) => sum + (itemScores[idx] || 0), 0);
    const dimMax = dim.items.length * 3;
    dimScores[dim.id] = { score:dimTotal, max:dimMax, pct:Math.round((dimTotal/dimMax)*100), label:dim.label, icon:dim.icon };
  });
  return { totalScore, maxScore, rawPct:Math.round((totalScore/maxScore)*100), percentile, band, itemScores, dimScores, scales:{ sjt_management:percentile } };
}
